import React from 'react';
import TddSyncPanel from './TddSyncPanel';

const TddSyncPage: React.FC = () => <TddSyncPanel />;

export default TddSyncPage;
